import { LOCALE_ID, NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpModule } from '@angular/http';

import { AboutPage } from '../pages/about/about';
import { ContactPage } from '../pages/contact/contact';
import { HomePage } from '../pages/home/home';
import { CalendarPage } from '../pages/calendar/calendar';
import { ProjectsPage } from '../pages/projects/projects';
import { TabsPage } from '../pages/tabs/tabs';
import { LoginPageModule } from '../pages/login/login.module';
import { InboxPageModule } from '../pages/inbox/inbox.module';
import { SelectMitarbeiterPageModule } from '../pages/select-mitarbeiter/select-mitarbeiter.module';
import { SelectProjectPageModule } from '../pages/select-project/select-project.module';
import { SelectLeistungPageModule } from '../pages/select-leistung/select-leistung.module';
import { LeistungstextPageModule } from '../pages/leistungstext/leistungstext.module';
import { LeistungDetailPageModule } from '../pages/leistung-detail/leistung-detail.module';
import { ProjectassignmentPageModule } from '../pages/projectassignment/projectassignment.module';
import { ExpensePageModule } from '../pages/expense/expense.module';
import { ExpenseItemDetailPageModule } from '../pages/expense-item-detail/expense-item-detail.module';
import { ExpenseItemCreatePageModule } from '../pages/expense-item-create/expense-item-create.module';
import { CalendarLeistungListePageModule } from '../pages/calendar-leistung-liste/calendar-leistung-liste.module';


import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { RhynoApiProvider } from '../providers/rhyno-api/rhyno-api';

import { PipesModule } from '../pipes/pipes.module';

import { LeistungProvider } from '../providers/leistung/leistung';
import { ChartsModule } from 'ng2-charts';


import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe);

export const firebaseConfig = {
    apiKey: "AIzaSyCx3mEC6TsfUJGtFx0HN7zjz_-dxj54lek",
    authDomain: "rhyno-zeit.firebaseapp.com",
    databaseURL: "https://rhyno-zeit.firebaseio.com",
    projectId: "rhyno-zeit",
    storageBucket: "",
    messagingSenderId: "90217566325"
  };


@NgModule({
  declarations: [
    MyApp,
    AboutPage,
    ContactPage,
    HomePage,
    CalendarPage,
    ProjectsPage,
    TabsPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {tabsPlacement: 'bottom',backButtonText: 'Zurück'}),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    HttpModule,
    PipesModule,
    LoginPageModule,
    InboxPageModule,
    SelectMitarbeiterPageModule,
    SelectProjectPageModule,
    SelectLeistungPageModule,
    LeistungstextPageModule,
    LeistungDetailPageModule,
    ProjectassignmentPageModule,
    ChartsModule,
    ExpensePageModule,
    ExpenseItemDetailPageModule,
    ExpenseItemCreatePageModule,
    CalendarLeistungListePageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AboutPage,
    ContactPage,
    HomePage,
    TabsPage,
    CalendarPage,
    ProjectsPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: LOCALE_ID, useValue: 'de' } ,
    RhynoApiProvider,
    LeistungProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts